import React from "react";
import { Modal, Row, Col, Typography, Spin, Button } from "antd";

const { Title, Text } = Typography;

/**
 * Modal de detalle y edición de empleado
 * @param {object} props
 * @param {boolean} props.visible
 * @param {function} props.onClose
 * @param {object} props.empleado
 * @param {function} props.onSave
 * @param {boolean} props.loading
 */
const EmpleadoDetalleModal = ({ visible, onClose, empleado, loading }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      title={<Title level={4}>Detalle del Empleado</Title>}
      footer={null}
      width={600}
    >
      {loading ? (
        <Spin />
      ) : empleado ? (
        <>
          <Row gutter={[16, 8]}>
            <Col span={12}><Text strong>Nombre:</Text> <Text>{empleado.nombre}</Text></Col>
            <Col span={12}><Text strong>Apellido:</Text> <Text>{empleado.ap_paterno} {empleado.ap_materno}</Text></Col>
            <Col span={12}><Text strong>Puesto:</Text> <Text>{empleado.puesto}</Text></Col>
            <Col span={12}><Text strong>Departamento:</Text> <Text>{empleado.departamento}</Text></Col>
            <Col span={12}><Text strong>Fecha de nacimiento:</Text> <Text>{empleado.fecha_nacimiento}</Text></Col>
            <Col span={12}><Text strong>Fecha de ingreso:</Text> <Text>{empleado.fecha_ingreso}</Text></Col>
            <Col span={12}><Text strong>Teléfono:</Text> <Text>{empleado.telefono}</Text></Col>
            <Col span={12}><Text strong>Email:</Text> <Text>{empleado.email}</Text></Col>
            <Col span={12}><Text strong>Salario:</Text> <Text>{empleado.salario}</Text></Col>
            <Col span={12}><Text strong>Estatus:</Text> <Text>{empleado.estatus}</Text></Col>
          </Row>
          <div style={{ marginTop: 24, textAlign: "right" }}>
            <Button onClick={onClose}>Cerrar</Button>
          </div>
        </>
      ) : null}
    </Modal>
  );
};

export default EmpleadoDetalleModal;
